import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import { chubStandards } from '../../../styles/typography';
import { ChubTableWrapper } from '../../../styles/table';
import ServerMessages from '../../../components/ServerMessages';

const Title = glamorous('h1', { displayName: 'Title' })(chubStandards, {
  size: '24px',
  textAlign: 'left',
  margin: '0 20px',
});

const PageMessagesWrapper = glamorous(ChubTableWrapper, { displayName: 'PageMessagesWrapper' })({
  maxWidth: '1300px',
  maxHeight: '600px',
  margin: '20px auto 0 auto',
  overflowX: 'hidden',
});

const PageMessages = ({ error, serverMessages }) => (
  <PageMessagesWrapper>
    {error && (
      <Fragment>
        <Title id='as2-stoppable-files'>Error Fetching Stoppable Files</Title>
      </Fragment>
    )}
    {!error && (
      <Fragment>
        <Title id='as2-stoppable-files'>Stoppable Files</Title>
        <ServerMessages {...{ serverMessages }} />
      </Fragment>
    )}
  </PageMessagesWrapper>
);

PageMessages.displayName = 'PageMessages';
PageMessages.propTypes = {
  error: PropTypes.string,
  serverMessages: PropTypes.array,
};

export default PageMessages;
